import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HomePage, PrivacyPage, SecurityPage } from "src/components/pages";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Lenis from "@studio-freight/lenis";
import AOS from "aos";
import "aos/dist/aos";
import "aos/dist/aos.css";
import { LenisContext } from "src/context/LenisContext";

export const Home: React.FC = () => {
  const [lenis, setLenis] = useState<Lenis | null>(null);

  useEffect(() => {
    const instance = new Lenis({
      smoothWheel: true,
      syncTouch: true,
      syncTouchLerp: 0.08,
      lerp: 0.1,
      touchMultiplier: 1.5,
      wheelMultiplier: 1,
      duration: 1.2,
    });
    setLenis(instance);

    function raf(time: number) {
      instance.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => instance.destroy();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1600,
      delay: 100,
    });
  }, []);

  return (
    <LenisContext.Provider value={lenis}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/security" element={<SecurityPage />} />
            {/* <Route path="/history" element={<History />} />
            <Route path="/news" element={<News />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/recruit" element={<JoinPage />} />
            <Route path="/recruit/detail" element={<JoinDetailPage />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/service" element={<ProductsPage />} />
            <Route path="/service/detail" element={<ProductDetail />} />
            <Route path="/reasons" element={<ReasonsPage />} /> */}
          </Routes>
        </Router>
      </I18nextProvider>
    </LenisContext.Provider>
  );
};

export default Home;
